<script setup lang="ts">
defineProps<{ event: EventCard }>()
</script>

<template>
  <CardsEventInfoCell v-if="event.location?.address" icon="far:house-blank">
    <a
      v-if="event.location.mapLink"
      :href="event.location.mapLink"
      v-text="event.location.address"
    />
    <span v-else v-text="event.location.address" />
  </CardsEventInfoCell>
</template>
